import { render, staticRenderFns } from "./OperaReductionWindow.vue?vue&type=template&id=3def5e5e&"
import script from "./OperaReductionWindow.vue?vue&type=script&lang=js&"
export * from "./OperaReductionWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports